import { module } from 'modujs';
import Splide from '@splidejs/splide';
import Env from '../base/env';

export default class extends module {
  constructor(m) {
    super(m);
  }

  init() {
    this.DOM = {};
    this.DOM.view = this.el;

    this.create();
  }

  create() {
    const modeMobile = Boolean(this.DOM.view.getAttribute('data-mobile-only'));
    const total = this.DOM.view.querySelectorAll('.splide__slide').length;
    const pagination = total > 1 ? true : false;
    const arrows = total > 1 ? true : false;
    this.slideshow = new Splide(this.DOM.view, {
      pagination: pagination,
      arrows: arrows,
      padding: { left: 0, right: 0 },
      type: 'fade',
      speed: 1000,
      gap: 0,
      autoplay: true,
      pauseOnHover: false,
      rewind: true,
    });
    if (modeMobile == true) {
      if (Env.mobileCSS) {
        this.slideshow.mount();
      }
    } else {
      this.slideshow.mount();
    }
  }

  destroy() {
    this.slideshow.destroy();
  }
}
